import ApplicationController from './application_controller'
import Rails from "@rails/ujs";
export default class extends ApplicationController {
  static targets = [ "hm0_output" ]
  connect () {
    console.log("Declaration competence JS en cours ...");
    super.connect();
    console.log("Declaration competence JS en cours ... 2");
  }
  beforeReflex (element, reflex, noop, reflexId) {
    $('.lds-ring').show();
  }
  afterReflex (element, reflex, noop, reflexId) {
    $('.lds-ring').hide();
  }
}
